export default {
  recipesNotAllowed: 'Piec nie jest skonfigurowany do używania receptur',
  recipesNotCreated: 'Brak dostępnych receptur',
};
